
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/california-search",
      function () {
        return require("private-next-pages/california-search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/california-search"])
      });
    }
  